import * as _ from "lodash";

import { Node } from "../Node";
import { _toThreeComplex, _toThreeValuePromise, AbstractProperty } from "./AbstractProperty";
import { json, MetadataRow } from "../../global";
import * as Commons from "oc-commons/Commons";
import { Vector2 } from "three";

export class PVector2 extends AbstractProperty<[number, number], Node> {
  default: [number, number];
  dimensionLabels: string[];

  constructor(args) {
    super({
      type: "Vector2",
      default: args.default ?? [0, 0],
      dimensionLabels: ["x", "y"],
      ...args,
    });
  }

  typeCheck(value) {
    return _.isArray(value) && value.length == 2;
  }

  isEqual(a: [number, number], b: [number, number]): boolean {
    return Commons.isEqualEpsilon(a, b);
  }

  toJSON(): json {
    return _.clone(this.get());
  }

  fromJSON(json: json): this {
    this.set(_.clone(json[this.name]));
    return this;
  }

  toThree(instance: any) {
    _toThreeComplex(
      this,
      instance,
      "Vector2",
      (instance, value) => _toThreeValuePromise(new Vector2()),
      (instance, value, instanceValue, freshlyCreated) => instanceValue.set(value[0], value[1]),
    );
  }

  threeToInternalFormat(value: any): string {
    return value?.toArray();
  }

  fromMetadataRow(metadataRow: MetadataRow): this {
    this.set(metadataRow[this.name]?.toArray());
    return this;
  }

  toMetadataRow(metadataRow: MetadataRow): this {
    metadataRow[this.name] = new Vector2().fromArray(this.get());
    return this;
  }
}
